// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface DropdownIconSignature {
  Element: SVGSVGElement;
}

export const DropdownIcon: TOC<DropdownIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.7501 15C11.5645 15 11.3888 14.9169 11.2701 14.7756L8.14508 11.0256C7.98945 10.8388 7.95633 10.58 8.05883 10.36C8.16195 10.1406 8.38195 10 8.62508 10H14.8751C15.1182 10 15.3382 10.1406 15.4413 10.36C15.5438 10.58 15.5101 10.8388 15.3545 11.025L12.2295 14.775C12.1113 14.9169 11.9357 15 11.7501 15Z"/>
</svg>
</template>;